/* Classic collection — tours migrated from the legacy myecotour.com site.
   Rendered as a compact grid on /tours below the signature journeys.
   Prices marked (est) are indicative until the concierge confirms. */

export const CLASSIC_TOURS = [
    {
        slug: "awesome-australia",
        priceInr: 249999,
        name: "Awesome Australia",
        strap: "The Land of Kangaroos, Reef to Red Centre",
        titleSuffix: "Luxury Private Tour of Australia",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/australia-premium.jpg",
        priceUsd: 2499,
        priceEur: 2320,
        duration: "8 – 22 days · 3 route options",
        bestTime: "September – May",
        regions: ["Sydney", "Melbourne", "Great Barrier Reef", "Uluru", "Tasmania"],
        summary:
            "Three customisable Australian adventures — the 7N/8D Essentials (Sydney, Melbourne, reef and Uluru), the 11N/12D Explorer adding Kangaroo Island wildlife, and the 21N/22D Extravaganza covering the entire continent from the Blue Mountains and Great Ocean Road to Tasmania, Adelaide, Cairns and the Gold Coast.",
        highlights: [
            "Sydney Opera House, Harbour Bridge & Blue Mountains",
            "Great Barrier Reef snorkel & glass-bottom adventures",
            "Uluru and the Red Centre at sunrise",
            "Kangaroo Island & Tasmania wildlife encounters",
            "Eco-friendly stays and culinary trails throughout",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Sydney", x: "Opera House, harbour sail, Bondi-to-Coogee coastal walk." },
            { d: "Days 4–5", t: "Melbourne", x: "Laneways, Great Ocean Road day, penguin parade." },
            { d: "Days 6–7", t: "Cairns & the Reef", x: "Great Barrier Reef cruise, Daintree rainforest edge." },
            { d: "Day 8+", t: "Uluru & beyond", x: "Red Centre sunrise — or extend into the Explorer / Extravaganza routes." },
        ],
        faqs: [
            { q: "What do the packages cost?", a: "Essentials of Australia (7N/8D) from ₹2,49,999 pp + taxes (~$2,499); Australia Explorer (11N/12D) from ₹2,99,999 pp + taxes; the 21N/22D Extravaganza is priced on request. All fully customisable." },
            { q: "Do you handle the Australian visa?", a: "We provide complete documentation support for the visitor visa (subclass 600) and recommend applying 6–8 weeks before travel." },
        ],
    },
    {
        slug: "spiritual-sojourn-ayodhya-kashi",
        name: "Spiritual Sojourn — Ayodhya, Kashi & Prayagraj",
        strap: "India's Sacred Heart in 12 Days",
        heroImage: "/api/assets/img/spiritual-sojourn-premium.jpg",
        priceUsd: 899,
        priceEur: 839,
        duration: "12 days · 11 nights",
        bestTime: "October – March",
        regions: ["Ayodhya", "Kashi (Varanasi)", "Prayagraj", "Lucknow"],
        summary:
            "A soul-stirring pilgrimage through India's spiritual heart — two nights in Ayodhya, birthplace of Lord Ram; three in Kashi, the eternal city of Varanasi; the sacred sangam of Prayagraj; and a graceful finale among the nawabi heritage of Lucknow — with exclusive spiritual experiences, luxury stays and a curated culinary journey.",
        highlights: [
            "Ram Mandir darshan & Saryu aarti in Ayodhya",
            "Private dawn boat on the Ganges & Ganga aarti at Dashashwamedh",
            "Sangam ritual at Prayagraj — confluence of three sacred rivers",
            "Lucknow's imambaras, chikankari ateliers & Awadhi dining",
            "Personalised puja arrangements and photography support",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Ayodhya", x: "The holy city — Ram Janmabhoomi, Hanuman Garhi, Saryu ghats." },
            { d: "Days 4–6", t: "Kashi (Varanasi)", x: "Kashi Vishwanath, dawn boats, evening aarti, Sarnath." },
            { d: "Days 7–8", t: "Prayagraj", x: "Sangam, Anand Bhavan, cultural immersion." },
            { d: "Days 9–11", t: "Lucknow", x: "Bara Imambara, heritage walk, Awadhi feast." },
            { d: "Day 12", t: "Departure", x: "Fly out of Lucknow." },
        ],
        faqs: [
            { q: "Is this suitable for elderly parents?", a: "Very much — private vehicles, wheelchair-accessible hotel picks, priority darshan assistance and an unhurried pace make it ideal for senior travellers." },
            { q: "Can we time it with a festival?", a: "Yes — Dev Deepawali in Kashi and Ram Navami in Ayodhya are extraordinary; both need booking 3–4 months ahead." },
        ],
    },
    {
        slug: "beautiful-bali",
        name: "Beautiful Bali",
        strap: "Budget to Luxury, Bali Beats Them All",
        titleSuffix: "Luxury Private Tour of Indonesia",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/bali-premium.jpg",
        priceUsd: 749,
        priceEur: 699,
        duration: "7 days · 6 nights",
        bestTime: "April – October",
        regions: ["Ubud", "Nusa Dua", "Uluwatu", "Nusa Penida"],
        summary:
            "Bali beats all destinations in budget-to-luxury range — for honeymooners and families alike. Rice-terrace villas in Ubud, temple sunrises, the cliffs of Uluwatu, Nusa Penida's wild coastline and beachfront evenings in Nusa Dua, all sequenced by a concierge who knows the island beyond the crowds.",
        highlights: [
            "Ubud rice-paddy pool villa & Tegallalang sunrise",
            "Tirta Empul water-blessing ceremony",
            "Nusa Penida island day — Kelingking & Crystal Bay",
            "Uluwatu cliff temple & kecak fire dance at sunset",
            "Beachfront candle-lit dinner in Nusa Dua",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Ubud", x: "Villa check-in, rice terraces, temples, jungle swing, spa." },
            { d: "Day 4", t: "Nusa Penida", x: "Fast-boat island day — viewpoints, snorkel, beach clubs." },
            { d: "Days 5–6", t: "Nusa Dua & Uluwatu", x: "Beach resort, water sports, cliff-temple sunset." },
            { d: "Day 7", t: "Departure", x: "Fly out of Denpasar." },
        ],
        faqs: [
            { q: "Honeymoon or family — which is it best for?", a: "Both. We run parallel curations: private pool villas and couple spa rituals for honeymooners; connecting rooms, kid-friendly beaches and safari parks for families." },
            { q: "Is Bali visa-free for Indians?", a: "Indonesia offers visa on arrival for Indian passport holders (fee applies) — we brief you on the latest requirements before travel." },
        ],
    },
    {
        slug: "mystical-bhutan",
        priceInr: 74999,
        name: "Mystical Bhutan",
        strap: "The Abode of Happiness in 7 Days",
        titleSuffix: "Luxury Private Tour of Bhutan",
        overline: "Premium Himalayan Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/bhutan-premium.jpg",
        priceUsd: 749,
        priceEur: 699,
        duration: "7 days · 6 nights",
        bestTime: "March – May · September – November",
        regions: ["Paro", "Thimphu", "Punakha", "Phobjikha"],
        summary:
            "Seven days in the Land of the Thunder Dragon — Paro's cliff-hung Tiger's Nest, Thimphu's living traditions, the fertility temples and river dzongs of Punakha and the glacial Phobjikha valley — travelling the world's only carbon-negative country with eco-luxury stays and Bhutanese feasts.",
        highlights: [
            "Tiger's Nest (Taktsang) monastery hike",
            "Punakha Dzong at the river confluence & suspension bridge",
            "Phobjikha valley — black-necked crane country",
            "Traditional hot-stone bath & Bhutanese cuisine journey",
            "All permits, SDF and English-speaking guide handled",
        ],
        itinerary: [
            { d: "Day 1", t: "Welcome to Paro", x: "Fly into the Himalayan amphitheatre, acclimatise, riverside stroll." },
            { d: "Day 2", t: "Thimphu", x: "Buddha Dordenma, weekend market, national institutes." },
            { d: "Days 3–4", t: "Punakha", x: "Dochula pass, Punakha Dzong, Chimi Lhakhang." },
            { d: "Day 5", t: "Phobjikha", x: "Gangtey monastery and valley nature trail." },
            { d: "Days 6–7", t: "Tiger's Nest & farewell", x: "The classic hike, celebratory dinner, departure." },
        ],
        faqs: [
            { q: "What are the package tiers?", a: "Standard ₹74,999, Premium ₹94,999 and Luxury ₹1,24,999 per person + taxes. Early-booking (90+ days) earns 10% off; groups of 4+ earn 5% off." },
            { q: "How do we reach Bhutan?", a: "Druk Air / Bhutan Airlines fly to Paro from Delhi and Kolkata; overland entry via Phuentsholing is also possible. We arrange everything including the SDF." },
        ],
    },
    {
        slug: "chardham-yatra",
        name: "Chardham Yatra",
        strap: "The Sacred Himalayan Circuit, Sustainably",
        heroImage: "/api/assets/img/chardham-premium.jpg",
        priceUsd: 1199,
        priceEur: 1119,
        duration: "10 – 12 days · road or helicopter",
        bestTime: "May – June · September – October",
        regions: ["Yamunotri", "Gangotri", "Kedarnath", "Badrinath"],
        summary:
            "A transformational pilgrimage to the four sacred shrines of the Garhwal Himalaya — Yamunotri, Gangotri, Kedarnath and Badrinath — by the traditional road circuit or time-saving helicopter services, with eco-friendly lodges, high-altitude health support and a footprint that gives back to mountain communities.",
        highlights: [
            "All four dhams with priority darshan assistance",
            "Helicopter option for time-conscious pilgrims",
            "Eco-friendly lodging along the entire route",
            "High-altitude health & safety protocols with oxygen support",
            "Carbon-conscious travel that supports local economies",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Haridwar → Yamunotri", x: "Ganga aarti, drive into the Yamuna valley, first darshan." },
            { d: "Days 3–4", t: "Gangotri", x: "Harsil valley, source-of-the-Ganges temple." },
            { d: "Days 5–7", t: "Kedarnath", x: "Trek or heli to the Kedar valley shrine." },
            { d: "Days 8–10", t: "Badrinath & return", x: "Mana village, Badrinath darshan, return via Rishikesh." },
        ],
        faqs: [
            { q: "Road or helicopter — which should we choose?", a: "The 10–12 day road yatra is the classic immersive route; the helicopter yatra covers all four dhams in 5–6 days and suits limited schedules or senior pilgrims. Both are fully escorted." },
            { q: "How fit do we need to be?", a: "Kedarnath involves a 16–18 km trek (ponies/palkis available). We include acclimatisation, medical screening advice and oxygen support throughout." },
        ],
    },
    {
        slug: "cherry-blossom-japan",
        name: "Cherry Blossom Japan Special",
        strap: "Sakura Season, Curated",
        titleSuffix: "Luxury Private Tour of Japan",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/cherry-blossom-japan-premium.jpg",
        priceUsd: 2999,
        priceEur: 2780,
        duration: "9 days · 8 nights",
        bestTime: "Late March – Mid April",
        regions: ["Tokyo", "Kyoto", "Hakone", "Osaka"],
        summary:
            "An unforgettable journey through Japan's breathtaking cherry-blossom season — hanami picnics beneath Tokyo's blooming avenues, Kyoto's temple gardens at peak sakura, Mt Fuji framed in pink at Hakone, and Osaka's castle moats petals-deep — with eco-conscious stays and bullet-train travel throughout.",
        highlights: [
            "Peak-bloom itinerary tuned to the sakura forecast",
            "Hanami picnic under Ueno / Maruyama park blossoms",
            "Mt Fuji & Chureito pagoda framed in cherry blossom",
            "Kyoto ryokan night with kaiseki dinner & onsen",
            "JR bullet-train pass and pocket wifi included",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Tokyo", x: "Ueno & Meguro river blossoms, teamLab, izakaya evening." },
            { d: "Day 4", t: "Hakone", x: "Fuji views, lake cruise, open-air museum, onsen ryokan." },
            { d: "Days 5–7", t: "Kyoto", x: "Philosopher's Path hanami, Gion tea ceremony, Arashiyama." },
            { d: "Days 8–9", t: "Osaka & departure", x: "Castle blossoms, Dotonbori food crawl, fly home." },
        ],
        faqs: [
            { q: "What if the bloom shifts?", a: "We track the official sakura forecast and hold flexible hotel blocks in two cities, adjusting your route north or south so you never miss peak bloom." },
            { q: "When should we book?", a: "Sakura season sells out earliest of any Japan window — reserve by November for late-March travel." },
        ],
    },
    {
        slug: "luxury-cruises",
        name: "MyEcoTour Cruises",
        strap: "Nordic · Alaska · Antarctica Expeditions",
        titleSuffix: "Eco-Luxury Expedition Cruises",
        overline: "Premium Expedition Voyages · USD & EUR pricing",
        heroImage: "/api/assets/img/cruises-premium.jpg",
        priceUsd: 3200,
        priceEur: 2980,
        duration: "7 – 14 days · 3 regions",
        bestTime: "May – Sep (North) · Nov – Mar (Antarctica)",
        regions: ["Nordic Fjords", "Alaska", "Antarctica"],
        summary:
            "Eco-conscious cruises to the world's most spectacular waters — Nordic fjords under the midnight sun or aurora, Alaska's calving glaciers and whale highways, and the White Continent itself, including an exclusive transformational Antarctica voyage with Deepak Chopra — aboard partnered expedition liners with dedicated guides.",
        highlights: [
            "Alaska voyages from $3,200 pp — glacier guarantees & naturalist lectures",
            "Antarctica expeditions from $7,500 pp — Zodiac landings & polar gear",
            "Nordic fjords, North Cape & aurora sailings",
            "Exclusive Deepak Chopra Antarctica wellness voyage",
            "Carbon-offset sailings with sustainable travel kits",
        ],
        itinerary: [
            { d: "Option 1", t: "Nordic Countries", x: "Fjords, iconic ports, midnight sun or Northern Lights." },
            { d: "Option 2", t: "Alaska (7–10 days)", x: "Inside Passage, Glacier Bay, whales and gold-rush ports." },
            { d: "Option 3", t: "Antarctica (10–14 days)", x: "Drake crossing, penguin colonies, Zodiac excursions." },
            { d: "Exclusive", t: "Deepak Chopra Voyage", x: "Wellness and adventure combined on the White Continent." },
        ],
        faqs: [
            { q: "What is included in the fares?", a: "Alaska: staterooms, all meals, select beverages, shore excursions and naturalist programmes from $3,200 (premium from $5,000). Antarctica: twin-share cabins, all meals and expedition drinks, polar gear rental and Zodiac excursions from $7,500 (premium suites from $12,000)." },
            { q: "Do I need prior expedition experience?", a: "None — expedition teams handle everything, and stabilised modern vessels plus doctor-onboard standards make these voyages accessible to first-timers." },
        ],
    },
    {
        slug: "swiss-cycling",
        name: "Cycling in the Swiss Countryside",
        strap: "The Alps on Two Wheels, 11 Days",
        titleSuffix: "Luxury Cycling Tour of Switzerland",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/swiss-cycling-premium.jpg",
        priceUsd: 3499,
        priceEur: 3250,
        duration: "11 days · 10 nights",
        bestTime: "June – September",
        regions: ["Lucerne", "Interlaken", "Zermatt", "Lake Geneva"],
        summary:
            "Discover the Swiss Alps on two wheels — an 11-day specially curated ride through idyllic villages, wildflower meadows, winding rivers and towering peaks, with routes graded for all abilities, e-bike options, sustainable accommodations and luggage transfers so you carry nothing but the view.",
        highlights: [
            "Routes for all abilities with premium e-bike options",
            "Alpine vistas: Jungfrau country, Matterhorn approaches",
            "Charming farm-stay and boutique sustainable hotels",
            "Vehicle-supported: luggage transfers & rest-day flexibility",
            "Cheese, chocolate and vineyard stops en route",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Lucerne & environs", x: "Lake loops, covered bridges, first alpine climbs." },
            { d: "Days 4–6", t: "Interlaken & Lauterbrunnen", x: "Waterfall valley rides beneath the Jungfrau." },
            { d: "Days 7–8", t: "Rhône valley → Zermatt", x: "Vineyard terraces, car-free Zermatt, Matterhorn views." },
            { d: "Days 9–11", t: "Lake Geneva", x: "Lavaux vineyards, Montreux lakeside finale." },
        ],
        faqs: [
            { q: "How fit do I need to be?", a: "Moderately — daily rides average 35–55 km with e-bike assistance available on every stage, and the support van is always within reach." },
            { q: "Can non-cycling partners join?", a: "Yes — they travel by scenic rail and meet you at each night's stop; Switzerland's trains make this seamless." },
        ],
    },
    {
        slug: "eastern-europe",
        name: "Eastern Europe Adventures",
        strap: "The Hidden Gems of the Old Continent",
        titleSuffix: "Luxury Private Tour of Eastern Europe",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/eastern-europe-premium.jpg",
        priceUsd: 1499,
        priceEur: 1399,
        duration: "8 – 16 days · 3 route options",
        bestTime: "April – October · December markets",
        regions: ["Prague", "Budapest", "Kraków", "Vienna", "Balkans"],
        summary:
            "Explore the hidden gems of Eastern Europe across three customisable routes — the 7N/8D Essentials (Prague, Vienna, Budapest), the 11N/12D Explorer adding Kraków and Bratislava, and the 15N/16D Wanderer reaching the Balkans — with cultural immersion, culinary trails and a transparent value-for-money pricing model.",
        highlights: [
            "Prague's old town & castle district at dawn",
            "Budapest thermal baths & Danube cruise",
            "Kraków, Auschwitz remembrance & Wieliczka salt mine",
            "Local-guide expertise and culinary immersions",
            "Happiness Guaranteed policy & full traveller support",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Prague", x: "Charles Bridge sunrise, castle, Bohemian dining." },
            { d: "Days 4–5", t: "Vienna", x: "Imperial palaces, coffee houses, opera evening." },
            { d: "Days 6–8", t: "Budapest", x: "Buda castle, ruin bars, Széchenyi baths." },
            { d: "Day 9+", t: "Explorer & Wanderer routes", x: "Kraków, Bratislava, then Slovenia and the Balkans." },
        ],
        faqs: [
            { q: "How does the pricing work?", a: "Transparent, custom quotes — we're not the cheapest but guarantee best value, will match any comparable eco-conscious package, and let you mix-and-match components to fit your budget. Indicative from $1,499 pp for the Essentials route." },
            { q: "Is one Schengen visa enough?", a: "Yes — all core destinations are Schengen; the Wanderer's Balkan extensions may need separate entries which we document for you." },
        ],
    },
    {
        slug: "enchanting-kashmir",
        name: "Enchanting Kashmir",
        strap: "Tulip Gardens, Dal Lake & the Himalayas",
        heroImage: "/api/assets/img/kashmir-premium.jpg",
        priceUsd: 799,
        priceEur: 749,
        duration: "7 days · 6 nights",
        bestTime: "March – April (tulips) · May – October",
        regions: ["Srinagar", "Gulmarg", "Pahalgam", "Sonamarg"],
        summary:
            "The towering Himalayas stand as eternal guardians over this enchanting region — Asia's largest tulip garden ablaze beneath the Zabarwan hills each spring, carved-walnut houseboats on Dal Lake, saffron fields, apple orchards and alpine meadows from Gulmarg to Pahalgam, with authentic Kashmiri wazwan and eco-conscious stays.",
        highlights: [
            "Indira Gandhi Tulip Garden in full spring bloom",
            "Heritage houseboat night & dawn shikara on Dal Lake",
            "Gulmarg gondola to Apharwat's snowfields",
            "Pahalgam's Lidder valley & saffron fields of Pampore",
            "Kahwa evenings and authentic wazwan feast",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Srinagar", x: "Houseboat check-in, tulip garden, Mughal gardens." },
            { d: "Days 3–4", t: "Gulmarg", x: "Gondola ride, meadow walks, optional skiing (winter)." },
            { d: "Days 5–6", t: "Pahalgam", x: "Betaab valley, riverside leisure, Aru meadows." },
            { d: "Day 7", t: "Departure", x: "Sonamarg detour or fly out of Srinagar." },
        ],
        faqs: [
            { q: "When do the tulips bloom?", a: "A short, spectacular window from late March to mid-April — the garden opens officially each spring and we time departures to peak bloom." },
            { q: "Is Kashmir suitable for families?", a: "Wonderfully — gentle pony rides, gondolas, lakes and orchards make it one of India's most family-friendly mountain escapes." },
        ],
    },
    {
        slug: "europe-splendour",
        priceInr: 299999,
        name: "Europe Splendour",
        strap: "The Grand Tour, Eco-Consciously",
        titleSuffix: "Luxury Private Tour of Europe",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/europe-splendour-premium.jpg",
        priceUsd: 2999,
        priceEur: 2780,
        duration: "8 – 21 days · 3 route options",
        bestTime: "April – October",
        regions: ["Paris", "Swiss Alps", "Amsterdam", "Rome", "Vienna"],
        summary:
            "Indulge in Europe's splendour across three customisable journeys — the 7N/8D European Essence, the 11N/12D European Explorer, and the 20N/21D Grand European Adventure — with eco-conscious accommodations, carbon-offset transport between destinations, exclusive experiences and loyalty-programme benefits throughout.",
        highlights: [
            "Paris, the Alps, Amsterdam, Rome — sequenced without rush",
            "Eco-conscious hotels & carbon-offset inter-city travel",
            "Exclusive MyEcoTour experiences & cultural immersions",
            "Early-booking incentives and loyalty rewards",
            "Fully customisable routes, hotels and pace",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Paris", x: "Louvre timed entry, Seine at dusk, Montmartre ateliers." },
            { d: "Days 4–5", t: "Swiss Alps", x: "Interlaken, Jungfrau rail, lake cruises." },
            { d: "Days 6–8", t: "Essence finale", x: "Amsterdam canals — or continue on the Explorer route." },
            { d: "Days 9–21", t: "Explorer & Grand routes", x: "Italy, Austria, Czechia and beyond on the longer journeys." },
        ],
        faqs: [
            { q: "What do the three packages cost?", a: "European Essence (7N/8D) ₹2,99,999 + taxes (~$2,999); European Explorer (11N/12D) ₹4,49,999 + taxes; Grand European Adventure (20N/21D) ₹7,99,999 + taxes — per person, including eco-stays, listed meals, guided experiences and carbon-offset inter-city transport. International flights quoted separately." },
            { q: "Can we customise the route?", a: "Every departure is private and built around you — swap cities, upgrade hotels, add the French Riviera or Greek islands at will." },
        ],
    },
    {
        slug: "italy-greece-spain",
        name: "Italy · Greece · Spain",
        strap: "The Land of Heritage & Romance",
        titleSuffix: "Luxury Private Tours of the Mediterranean",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/italy-greece-spain-premium.jpg",
        priceUsd: 2499,
        priceEur: 2320,
        duration: "8 – 12 days · 5 route options",
        bestTime: "April – June · September – October",
        regions: ["Rome", "Amalfi Coast", "Venice", "Barcelona", "French Riviera"],
        summary:
            "Five sustainable-luxury Mediterranean routes ex-Milan or Rome — the Italian Essentials (Milan, Venice, Florence, Rome), the 11N/12D Italy Explorer adding Lake Como, Tuscany, Amalfi and Pompeii, Italy & Spain (Barcelona, Madrid), Italy & Switzerland, or Italy with the French Riviera (Nice, Monaco, Cannes, Saint-Tropez).",
        highlights: [
            "Venice gondola quarter & Florence's Renaissance core",
            "Amalfi coast drives and Pompeii with an archaeologist",
            "Barcelona's Gaudí trail & Madrid's golden triangle of art",
            "Swiss Alps or French Riviera combinations",
            "Limited-time offers on spring & autumn departures",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Milan / Lake Como", x: "Duomo, Last Supper slot, lakeside villages." },
            { d: "Days 3–4", t: "Venice", x: "St Mark's, gondola, Murano-Burano." },
            { d: "Days 5–6", t: "Florence & Tuscany", x: "Uffizi, Chianti hills, artisan workshops." },
            { d: "Days 7–8", t: "Rome", x: "Colosseum, Vatican, trastevere evenings." },
            { d: "Days 9–12", t: "Amalfi / Spain / Riviera", x: "Choose your finale — coast, Barcelona-Madrid or Nice-Monaco." },
        ],
        faqs: [
            { q: "Which route is best for honeymooners?", a: "Italy with the French Riviera — Venice, Tuscany and Rome, closing among the beaches and casinos of Nice, Monaco and Saint-Tropez." },
            { q: "How much walking is involved?", a: "Historic centres are pedestrian — expect 6–8 km strolling days, always at your own pace with skip-the-line entries." },
        ],
    },
    {
        slug: "kerala-karnataka-odyssey",
        name: "South India Odyssey — Kerala & Karnataka",
        strap: "Backwaters, Coffee Hills & Stone Cities",
        heroImage: "/api/assets/img/kerala-karnataka-premium.jpg",
        priceUsd: 899,
        priceEur: 839,
        duration: "7 – 15 days · 3 route options",
        bestTime: "October – March",
        regions: ["Kochi", "Munnar", "Alleppey", "Coorg", "Mysore", "Hampi"],
        summary:
            "Three unforgettable South Indian journeys — the 6N/7D Kerala Essence (Kochi, Munnar, Thekkady, Alleppey), the 9N/10D Kerala & Coorg Fusion adding Wayanad and coffee country, and the epic 14N/15D South Indian Odyssey continuing through Mysore's palaces, Hampi's boulder-strewn ruins and Gokarna's beaches to Goa.",
        highlights: [
            "Private houseboat night on the Alleppey backwaters",
            "Munnar tea estates & Thekkady spice plantations",
            "Coorg coffee-estate stay and Wayanad's green hills",
            "Mysore Palace and UNESCO Hampi with historians",
            "Award-winning eco-conscious operator, early-bird discounts",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Kochi", x: "Fort Kochi walk, Kathakali evening, chinese nets." },
            { d: "Days 3–4", t: "Munnar", x: "Tea-estate stay, Eravikulam, spice gardens." },
            { d: "Days 5–7", t: "Thekkady & Alleppey", x: "Periyar boat, houseboat night on the backwaters." },
            { d: "Days 8–10", t: "Wayanad & Coorg", x: "Waterfalls, coffee estates, Kodava cuisine." },
            { d: "Days 11–15", t: "Mysore · Hampi · Gokarna · Goa", x: "Palaces, ruins and the Konkan coast finale." },
        ],
        faqs: [
            { q: "Which option should we choose?", a: "Kerala Essence for a first taste (6N/7D); the Fusion for hills-plus-coffee (9N/10D); the full Odyssey (14N/15D) if you want backwaters to boulders in one sweep." },
            { q: "Is the houseboat private?", a: "Yes — a full private kettuvallam with crew, chef and sundeck; premium and deluxe categories available." },
        ],
    },
    {
        slug: "london-scotland",
        name: "London & Scotland",
        strap: "London Bridge Is Calling — Since Childhood",
        titleSuffix: "Luxury Private Tour of the United Kingdom",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/london-scotland-premium.jpg",
        priceUsd: 1999,
        priceEur: 1860,
        duration: "8 – 22 days · 3 route options",
        bestTime: "May – September · December lights",
        regions: ["London", "Windsor", "Edinburgh", "Highlands", "Paris"],
        summary:
            "Three UK journeys with our Happiness Guaranteed policy — the 7N/8D London Essentials (Windsor, Oxford, Cotswolds, Stonehenge and Bath), the 11N/12D London & Scotland Explorer (York, Edinburgh, the Highlands, Glasgow), and the 21N/22D London-Scotland-Paris Extreme for the complete once-in-a-lifetime sweep.",
        highlights: [
            "London's icons with priority entries & West End evening",
            "Windsor Castle, Oxford, Cotswolds villages, Stonehenge & Bath",
            "Edinburgh's Royal Mile and Highland lochs & castles",
            "Optional gourmet culinary experiences",
            "Personalised service with exclusive member benefits",
        ],
        itinerary: [
            { d: "Days 1–3", t: "London icons", x: "Tower, Westminster, museums, London Eye at dusk." },
            { d: "Day 4", t: "Windsor", x: "Castle day trip and river afternoon." },
            { d: "Days 5–6", t: "Oxford · Cotswolds · Stonehenge · Bath", x: "England's golden circuit." },
            { d: "Days 7–8", t: "London at leisure", x: "Markets, afternoon tea — or continue north." },
            { d: "Days 9+", t: "Scotland & Paris routes", x: "York, Edinburgh, Highlands, Glasgow; Paris on the Extreme." },
        ],
        faqs: [
            { q: "Do we need separate visas for Paris?", a: "Yes — the UK visa covers Britain; the Paris leg needs a Schengen visa. We prepare both applications together." },
            { q: "When are the Highlands at their best?", a: "May, June and September — long days, purple heather (late Aug–Sep) and fewer midges than high summer." },
        ],
    },
    {
        slug: "magical-ladakh",
        name: "Magical Ladakh",
        strap: "The Land of Mystics at 3,500m",
        heroImage: "/api/assets/img/ladakh-premium.jpg",
        priceUsd: 1099,
        priceEur: 1020,
        duration: "8 days · 7 nights",
        bestTime: "May – September",
        regions: ["Leh", "Sham Valley", "Nubra", "Pangong"],
        summary:
            "A 7N/8D eco-luxury expedition through the Land of Mystics — Leh's heritage lanes and hilltop monasteries, the Sham valley's confluence viewpoints, Nubra's double-humped camels among the dunes, and the impossible blues of Pangong Tso — with careful acclimatisation and a give-back programme for Ladakhi communities.",
        highlights: [
            "Thiksey & Hemis monasteries with morning prayers",
            "Khardung La crossing into the Nubra valley",
            "Bactrian camel ride on the Hunder dunes",
            "Sunrise at Pangong Lake's shifting blues",
            "Eco-luxury camps & giving back to Ladakh initiatives",
        ],
        itinerary: [
            { d: "Day 1", t: "Welcome to Leh (3,500m)", x: "Fly in, full acclimatisation day, gentle old-town walk." },
            { d: "Day 2", t: "Leh heritage", x: "Palace, Shanti stupa, monastery circuit." },
            { d: "Day 3", t: "Sham Valley", x: "Magnetic hill, Sangam confluence, Alchi." },
            { d: "Days 4–5", t: "Nubra Valley", x: "Khardung La, Diskit Buddha, dune camp night." },
            { d: "Days 6–7", t: "Pangong & return", x: "Lakeside sunset and sunrise, back over Chang La." },
            { d: "Day 8", t: "Departure", x: "Morning flight out of Leh." },
        ],
        faqs: [
            { q: "How do you handle altitude?", a: "Day one is a mandated rest day, routes ascend gradually, and our vehicles carry oxygen — the vast majority of guests acclimatise comfortably." },
            { q: "Do we need permits?", a: "Inner Line Permits for Nubra and Pangong are required — we arrange them in advance for both Indian and foreign nationals." },
        ],
    },
    {
        slug: "east-himalaya",
        priceInr: 99999,
        name: "Magnificent East Himalaya",
        strap: "Sikkim & Darjeeling Treasure Trove",
        heroImage: "/api/assets/img/east-himalaya-premium.jpg",
        priceUsd: 999,
        priceEur: 929,
        duration: "12 days · 11 nights",
        bestTime: "March – May · October – December",
        regions: ["Kurseong", "Darjeeling", "Kalimpong", "Gangtok"],
        summary:
            "A 12-day sustainable journey through the Eastern Himalaya — Kurseong's white-orchid ridges, Darjeeling's toy train and Kanchenjunga dawns, Kalimpong's nurseries and monasteries, and Gangtok, the crown jewel of Sikkim — where luxury stays meet community-first travel.",
        highlights: [
            "Tiger Hill sunrise over Kanchenjunga",
            "Darjeeling Himalayan Railway joyride & tea-estate tastings",
            "Kalimpong's horticulture and heritage walks",
            "Gangtok's MG Marg, Rumtek & Tsomgo lake excursion",
            "Luxury-meets-sustainability accommodations throughout",
        ],
        itinerary: [
            { d: "Day 1", t: "Bagdogra arrival", x: "Meet & drive into the hills." },
            { d: "Days 2–3", t: "Kurseong", x: "Land of white orchids — tea gardens and ridge walks." },
            { d: "Days 4–6", t: "Darjeeling", x: "Toy train, Tiger Hill, HMI and mall-road evenings." },
            { d: "Days 7–8", t: "Kalimpong", x: "Nurseries, Durpin monastery, river valley." },
            { d: "Days 9–11", t: "Gangtok", x: "Rumtek, Tsomgo lake, local immersion." },
            { d: "Day 12", t: "Farewell", x: "Drive down to Bagdogra for departure." },
        ],
        faqs: [
            { q: "What does it cost?", a: "From ₹99,999 per person + taxes on double occupancy (~$999). Early-bird bookings 120 days out earn 10% off; groups of 4+ save a further 5%." },
            { q: "Will we see Kanchenjunga?", a: "October–December and March–April offer the clearest views — Tiger Hill at dawn delivers the classic golden summit panorama." },
        ],
    },
    {
        slug: "mango-tourism",
        name: "Mango Tourism",
        strap: "The New Craze — Orchard Weekends",
        heroImage: "/api/assets/img/mango-tourism-premium.jpg",
        priceUsd: 349,
        priceEur: 325,
        duration: "2 – 3 days · weekend getaways",
        bestTime: "May – June (harvest)",
        regions: ["Malihabad", "Konkan", "The Baghaan (near Delhi)"],
        summary:
            "India's most delicious new travel craze — weekend escapes to the country's great mango capitals: Malihabad's Dussehri heartland near Lucknow, the Konkan coast's Alphonso estates, and The Baghaan retreat near Delhi — with orchard walks, tasting flights, harvest experiences and luxurious farm stays.",
        highlights: [
            "Orchard-to-table tastings of Dussehri, Alphonso & more",
            "Harvest-season picking experiences with growers",
            "Luxurious farm-stay accommodations",
            "Mango-menu dining: aamras to smoked-mango cocktails",
            "Perfect 2-day escapes from Delhi, Mumbai & Lucknow",
        ],
        itinerary: [
            { d: "Option 1", t: "Malihabad (2 days)", x: "The mango capital of India — heritage orchards, GI-tag varieties." },
            { d: "Option 2", t: "Konkan (2 days)", x: "Home of the Alphonso — coastal estates and sea breezes." },
            { d: "Option 3", t: "The Baghaan (2 days)", x: "A mango retreat within reach of Delhi." },
        ],
        faqs: [
            { q: "When is harvest season?", a: "Mid-May through June is peak — trees heavy with fruit, daily pickings and the full tasting spectrum. Book by April." },
            { q: "Is it family-friendly?", a: "Made for it — kids pick their own fruit, farms have pools and open lawns, and stays are all ground-floor comfortable." },
        ],
    },
    {
        slug: "mystical-northeast",
        priceInr: 99999,
        name: "Mystical NorthEast — The AAM Tour",
        strap: "Assam · Arunachal · Meghalaya",
        heroImage: "/api/assets/img/northeast-premium.jpg",
        priceUsd: 1250,
        priceEur: 1160,
        duration: "12 days · 3 route options",
        bestTime: "October – April",
        regions: ["Kaziranga", "Majuli", "Tawang", "Shillong", "Cherrapunji"],
        summary:
            "The ultimate AAM (Assam, Arunachal & Meghalaya) journey in three 12-day flavours — Awesome Assam (Kaziranga's rhinos, Majuli's river island, Sivasagar), the Assam & Arunachal Expedition (Ziro valley, Tawang's great monastery), or Assam & Meghalaya Magic (Shillong, Cherrapunji's living-root bridges, Asia's cleanest village Mawlynnong).",
        highlights: [
            "Kaziranga jeep & elephant-grass safaris — one-horned rhinos",
            "Majuli, the world's largest river island, by ferry",
            "Tawang monastery at 3,048m via Sela pass",
            "Living-root bridges & waterfalls of Cherrapunji",
            "Mawlynnong — Asia's cleanest village",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Guwahati & Kaziranga", x: "Kamakhya temple, park safaris at dawn and dusk." },
            { d: "Days 4–6", t: "Majuli / Ziro / Shillong", x: "Route-dependent — island satras, apatani valley or pine city." },
            { d: "Days 7–9", t: "Tawang / Cherrapunji", x: "High monastery circuit — or root bridges and waterfalls." },
            { d: "Days 10–12", t: "Return leg", x: "Nameri or Mawlynnong, back to Guwahati for departure." },
        ],
        faqs: [
            { q: "What do the options cost?", a: "Awesome Assam ₹99,999 pp + taxes (foreign nationals USD 1,250); Assam & Arunachal or Assam & Meghalaya ₹1,09,999 pp + taxes (USD 1,650). Single supplement ₹35,000 / USD 450." },
            { q: "Are permits needed?", a: "Arunachal requires an Inner Line Permit (Indians) or PAP (foreigners) — we arrange all permits before you fly." },
        ],
    },
    {
        slug: "northern-lights-arctic",
        name: "Northern Lights & Arctic Extravaganza",
        strap: "Chasing the Aurora, Premium Style",
        titleSuffix: "Premium Aurora & Arctic Experience",
        overline: "Premium Polar Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/northern-lights-premium.jpg",
        priceUsd: 3499,
        priceEur: 3250,
        duration: "9 days · 2 itinerary options",
        bestTime: "November – March",
        regions: ["Tromsø", "Bergen", "Helsinki", "Rovaniemi"],
        summary:
            "Two unforgettable aurora itineraries — Norway's Fjords & Arctic Adventure (Oslo, four nights in Tromsø the aurora capital, UNESCO Bergen and the Norway-in-a-Nutshell rail) or Finnish Lapland & Baltic Cruise (design-capital Helsinki, a Tallinn day-cruise, and five nights in Rovaniemi, Santa's official hometown) — with expert guides, photography support and luxury stays.",
        highlights: [
            "Multi-night aurora hunts with local experts & photographers",
            "Tromsø: fjord cruises, Sami reindeer encounters",
            "Norway in a Nutshell — the world's great rail journey",
            "Rovaniemi: Santa's village, husky & snowmobile safaris",
            "Glass-igloo / luxury cabin upgrade options",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Oslo / Helsinki", x: "Capital immersion — Viking heritage or Nordic design." },
            { d: "Days 3–6", t: "Tromsø / Rovaniemi", x: "Aurora expeditions nightly, arctic activities daily." },
            { d: "Days 7–8", t: "Bergen / Tallinn", x: "UNESCO wharf city — or the Baltic day-cruise." },
            { d: "Day 9", t: "Farewell", x: "Nutshell rail finale or Helsinki departure." },
        ],
        faqs: [
            { q: "Are the lights guaranteed?", a: "Nature makes no promises — but 4–5 nights above the Arctic Circle in season gives most guests multiple sightings, and our guides chase clear skies by minibus." },
            { q: "How cold does it get?", a: "-5°C to -20°C. Thermal suits and boots are provided for all night expeditions." },
        ],
    },
    {
        slug: "philippines-explorer",
        name: "Philippines Explorer",
        strap: "The Hot Destination of the Year",
        titleSuffix: "Luxury Private Tour of the Philippines",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/philippines-premium.jpg",
        priceUsd: 1299,
        priceEur: 1210,
        duration: "8 – 22 days · 3 route options",
        bestTime: "November – May",
        regions: ["Manila", "Bohol", "Cebu", "El Nido", "Coron"],
        summary:
            "Three customisable island adventures — the 7N/8D Essentials (Manila, Bohol's Chocolate Hills, Cebu, El Nido), the 11N/12D Explorer adding Tagaytay, Kawasan Falls and Coron, and the epic 21N/22D Vietnam & Philippines Extreme combining Hanoi, Ha Long Bay and the Mekong with the full Philippine island circuit.",
        highlights: [
            "El Nido & Coron island-hopping — lagoons and shipwreck snorkels",
            "Bohol: Chocolate Hills and tarsier sanctuaries",
            "Cebu's Kawasan Falls and Moalboal sardine run",
            "15+ curated experiences with 24/7 local support",
            "100% Happiness Guaranteed policy",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Manila", x: "Intramuros walk, Tagaytay volcano views." },
            { d: "Days 3–4", t: "Bohol", x: "Chocolate Hills, Loboc river, tarsiers." },
            { d: "Days 5–6", t: "Cebu", x: "Kawasan canyoneering, island paradise beaches." },
            { d: "Days 7–8", t: "El Nido", x: "Big & small lagoon hopping, sunset beach." },
            { d: "Days 9+", t: "Explorer & Extreme routes", x: "Coron wrecks — or the full Vietnam combination." },
        ],
        faqs: [
            { q: "Is the Philippines visa-easy for Indians?", a: "Indian passport holders with a valid US, Japan, Australia, Canada, Schengen, Singapore or UK visa enjoy visa-free entry (14 days); otherwise an e-visa applies. We guide you through it." },
            { q: "Which islands for honeymooners?", a: "El Nido and Coron — private island picnics, overwater sunsets and some of Asia's best-value luxury resorts." },
        ],
    },
    {
        slug: "rann-utsav",
        priceInr: 25999,
        name: "Rann Utsav",
        strap: "The White Desert's Cultural Renaissance",
        heroImage: "/api/assets/img/rann-utsav-premium.jpg",
        priceUsd: 259,
        priceEur: 239,
        duration: "3 days · 2 nights (Tent City)",
        bestTime: "November – March · full-moon nights",
        regions: ["Dhordo", "Great Rann of Kutch", "Bhuj"],
        summary:
            "An immense expanse of white salt stretching to the horizon — most magical under the full moon, when the crystalline surface glows like snow. Stay at the celebrated Dhordo Tent City (a UN Best Tourism Village), immerse in Kutchi dance, craft workshops and cuisine, and ride camel carts into the shimmering white at sunset.",
        highlights: [
            "Full-moon night on the glowing white salt desert",
            "Tent City stay — Swiss cottages to premium AC tents",
            "Kutchi folk dance, music & living craft workshops",
            "Camel-cart sunset rides & optional adventure zone",
            "Bhuj heritage and artisan-village excursions",
        ],
        itinerary: [
            { d: "Day 1", t: "Arrival & Tent City", x: "Check in at Dhordo, cultural evening, first white-desert sunset." },
            { d: "Day 2", t: "The Rann in full", x: "Sunrise on the salt, craft villages, folk performances, moonlit desert." },
            { d: "Day 3", t: "Bhuj & departure", x: "Aina Mahal, local markets, drive back." },
        ],
        faqs: [
            { q: "What do the tents cost?", a: "Per person, twin-sharing (2025–26 season): Non-AC Swiss Cottage ₹25,999, Deluxe AC Swiss Cottage ₹32,999, Premium AC Tent ₹39,999 (+5% GST). Full-moon dates sell out first." },
            { q: "When exactly should we go?", a: "The Utsav runs November to March; plan around a full-moon night — the desert's glow is otherworldly. December–January offers the coolest weather." },
        ],
    },
    {
        slug: "scenic-sri-lanka",
        name: "Scenic Sri Lanka",
        strap: "The Teardrop Isle, Three Ways",
        titleSuffix: "Luxury Private Tour of Sri Lanka",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/sri-lanka-premium.jpg",
        priceUsd: 999,
        priceEur: 929,
        duration: "8 – 12 days · 3 route options",
        bestTime: "December – April (west/south) · May – Sep (east)",
        regions: ["Sigiriya", "Kandy", "Nuwara Eliya", "Yala", "Bentota"],
        summary:
            "Three ways to love the teardrop isle — the 7N/8D Cultural Triangle & Beach (Sigiriya, Dambulla, Kandy, Bentota), the comprehensive 11N/12D tour adding Anuradhapura, Ella's tea country and Yala's leopards, or the 11N/12D Ramayana Circuit tracing the epic from Chilaw to Kataragama.",
        highlights: [
            "Sigiriya rock fortress at golden hour",
            "Kandy's Temple of the Tooth & cultural show",
            "Ella's train ride through emerald tea country",
            "Yala safari — the world's densest leopard population",
            "Ramayana Circuit option for pilgrim travellers",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Colombo & Negombo", x: "Arrival, lagoon fishing villages, city highlights." },
            { d: "Days 3–4", t: "Sigiriya & Dambulla", x: "Lion Rock climb, cave temples, village lunch." },
            { d: "Day 5", t: "Kandy", x: "Tooth Relic temple, botanical gardens." },
            { d: "Days 6–7", t: "Bentota / Nuwara Eliya", x: "Beach finale — or tea hills and Ella on the longer routes." },
            { d: "Days 8–12", t: "Yala & Ramayana extensions", x: "Leopard safaris or the full epic circuit." },
        ],
        faqs: [
            { q: "Which route for wildlife lovers?", a: "The 11N/12D comprehensive tour — Yala's leopards, Minneriya's elephant gathering (Aug–Sep) and Bundala's birdlife." },
            { q: "What about the Ramayana Circuit?", a: "An 11N/12D pilgrimage from Chilaw's Munneswaram to Sita Eliya and Kataragama, guided by scholars of the epic — deeply moving for devotee travellers." },
        ],
    },
    {
        slug: "enchanting-vietnam",
        name: "Enchanting Vietnam",
        strap: "From Ha Long Bay to the Mekong",
        titleSuffix: "Luxury Private Tour of Vietnam",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/vietnam-premium.jpg",
        priceUsd: 1099,
        priceEur: 1020,
        duration: "8 – 22 days · 3 route options",
        bestTime: "October – April",
        regions: ["Hanoi", "Ha Long Bay", "Sapa", "Ho Chi Minh City", "Con Dao"],
        summary:
            "Three enchanting Vietnamese journeys — the 7N/8D Essentials (Hanoi, an overnight Ha Long Bay cruise, Ho Chi Minh City and the Mekong Delta), the 11N/12D Explorer adding Sapa's mountain terraces, and the 21N/22D Extreme reaching Ninh Binh, Phong Nha's caves, Dalat and the hidden-paradise Con Dao islands.",
        highlights: [
            "Overnight luxury junk cruise on UNESCO Ha Long Bay",
            "Hanoi old quarter street-food evenings",
            "Mekong Delta river life by sampan",
            "Sapa rice terraces & hill-tribe homestays",
            "Con Dao — Vietnam's hidden island paradise",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Hanoi", x: "Old quarter, water puppets, Ho Chi Minh complex." },
            { d: "Day 4", t: "Ha Long Bay", x: "Overnight cruise among the karsts, kayaking, tai chi dawn." },
            { d: "Days 5–6", t: "Ho Chi Minh City", x: "Cu Chi tunnels, colonial quarter, rooftop evening." },
            { d: "Days 7–8", t: "Mekong Delta", x: "Floating markets, coconut villages, departure." },
            { d: "Days 9+", t: "Explorer & Extreme routes", x: "Sapa, Ninh Binh, Phong Nha, Dalat and Con Dao." },
        ],
        faqs: [
            { q: "Is Vietnam good value for luxury?", a: "Exceptional — five-star stays, private guides and overnight cruises cost a fraction of comparable destinations, which is why it tops our value rankings." },
            { q: "Do Indians need a visa?", a: "Yes — Vietnam's e-visa is straightforward (about 3 working days); we handle the paperwork with your booking." },
        ],
    },
    {
        slug: "rural-tourism",
        name: "Rural Tourism India",
        strap: "Village Homestays, Pottery & the Slow India",
        titleSuffix: "Village Homestays & Craft Immersions",
        overline: "Slow Travel · India's Living Villages",
        heroImage: "/api/assets/img/rural-tourism-premium.jpg",
        priceInr: 49999,
        priceUsd: 599,
        priceEur: 559,
        duration: "4 days · 3 nights · fully customisable",
        bestTime: "Year-round · October – March ideal",
        regions: ["Rural Rajasthan", "Konkan Coast", "Kutch", "Tribal Chhattisgarh", "North East India"],
        summary:
            "Step off the tourist trail and into India's living villages — three nights in a hand-picked rural homestay with pottery learning at the village wheel, farm-to-table meals cooked on wood fires, artisan craft workshops and unhurried walks through fields and hamlets. Choose your canvas: Rajasthan's mud-painted villages, the Konkan's mango and rice coast, Kutch's craft villages, the tribal heartlands of Chhattisgarh or the hill hamlets of the North East — and we'll customise the same slow, soulful immersion almost anywhere in India.",
        highlights: [
            "3 nights in a curated village homestay — real families, real hospitality",
            "Learn pottery at the village wheel with a master potter",
            "Farm-to-table meals — cook with your hosts on a wood-fired chulha",
            "Artisan immersions: weaving, block-printing, bamboo craft or Warli art by region",
            "Village walks, bullock-cart rides, and evenings of folk music under the stars",
            "Highly customisable — Rajasthan, Konkan, Kutch, Chhattisgarh, North East & beyond",
        ],
        itinerary: [
            { d: "Day 1", t: "Arrival & village welcome", x: "Private transfer from the nearest railhead or airport, traditional welcome, orientation walk and a home-cooked dinner with your host family." },
            { d: "Day 2", t: "Pottery & the artisan trail", x: "Morning at the village potter's wheel — shape, throw and fire your own piece. Afternoon with regional artisans: weavers, block-printers or bamboo craftsmen." },
            { d: "Day 3", t: "Farm, field & folk", x: "Join the morning farm routine, cook a farm-to-table lunch on a wood fire, evening bullock-cart ride and folk performance under the stars." },
            { d: "Day 4", t: "Slow morning & departure", x: "Unhurried breakfast, collect your fired pottery keepsake, and depart — or extend into a second region." },
        ],
        faqs: [
            { q: "What does the package cost?", a: "₹49,999 per person + taxes for 3 nights / 4 days — including the homestay, all meals, the pottery learning session, artisan workshops and local experiences. Transfers and any flights are quoted separately." },
            { q: "Which regions can I choose?", a: "Our curated bases are rural Rajasthan, the Konkan coast, Kutch, the tribal villages of Chhattisgarh and the states of the North East — but the journey is highly customisable and we can craft the same immersion in most rural regions of India." },
            { q: "Is this suitable for families and children?", a: "Wonderfully so — pottery, farm mornings and bullock-cart rides are loved by children, and homestay families are warm, patient hosts. We match you with the right village and home for your group." },
            { q: "How comfortable are the homestays?", a: "Hand-picked for cleanliness, character and warmth — private rooms with attached or dedicated washrooms, fresh linen and home-cooked food. Rustic by design, never rough." },
        ],
    },
    {
        slug: "underwater-odyssey",
        name: "Underwater Odyssey",
        strap: "Coral Reefs, Mantas & the Blue Wilderness",
        titleSuffix: "Scuba & Freediving Journeys",
        overline: "Adventure Collection · Dive Journeys",
        heroImage: "/api/assets/img/underwater-odyssey-premium.jpg",
        priceInr: 99999,
        priceUsd: 1199,
        priceEur: 1119,
        duration: "5 – 10 days · try-dive to certification",
        bestTime: "Year-round · varies by reef",
        regions: ["Andaman Islands", "Maldives", "Lakshadweep", "Raja Ampat", "Great Barrier Reef"],
        summary:
            "Slip beneath the surface into the planet's most alive wilderness — coral gardens of the Andamans, manta cleaning stations in the Maldives, the untouched atolls of Lakshadweep, and the world's richest reefs at Raja Ampat. From first-breath try-dives to full PADI/SSI certification, every journey pairs small-group instruction with coral-positive eco resorts.",
        highlights: [
            "PADI / SSI certified instructors — try-dive, Open Water or Advanced courses",
            "Manta rays, turtles, reef sharks & seasonal whale-shark encounters",
            "Eco dive resorts with house reefs steps from your villa",
            "Coral-positive operators — a share of your booking funds reef restoration",
            "Non-diver friendly: snorkel safaris, glass-bottom and freediving intros",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Arrival & confined water", x: "Settle into your dive resort, gear fitting, theory and first confined-water session with your instructor." },
            { d: "Days 3–4", t: "Reef immersion", x: "Two boat dives a day on house and signature reefs — coral gardens, turtle stations, drift lines." },
            { d: "Day 5+", t: "Signature dives", x: "Manta point, night dive or wreck — plus certification sign-off for course guests." },
            { d: "Extensions", t: "Island hop", x: "Add Neil Island, a Maldives liveaboard leg, or the crossing to Raja Ampat." },
        ],
        faqs: [
            { q: "I've never dived — can I join?", a: "Absolutely. Try-dives need no experience and take one morning. Full Open Water certification takes 3–4 days and is built into the journey. Swimmers of basic ability are welcome." },
            { q: "What does it cost?", a: "From ₹99,999 per person + taxes for a 5-day Andaman dive journey including stays, dives/course fees and transfers. Maldives, Lakshadweep and Raja Ampat itineraries are quoted per season by the concierge." },
            { q: "When is the best season?", a: "Andamans: October–May. Maldives: year-round (manta season May–November). Raja Ampat: October–April. We match the reef to your dates." },
        ],
    },
    {
        slug: "skydive-the-world",
        name: "Skydive the World",
        strap: "Freefall Over the Planet's Greatest Views",
        titleSuffix: "Tandem Skydive Journeys",
        overline: "Adventure Collection · Skydive Journeys",
        heroImage: "/api/assets/img/skydive-premium.jpg",
        priceInr: 199999,
        priceUsd: 2399,
        priceEur: 2249,
        duration: "3 – 7 days · jump + luxury city break",
        bestTime: "Year-round · destination dependent",
        regions: ["Dubai — The Palm", "Interlaken", "Queenstown NZ", "Seville", "Mysore India"],
        summary:
            "Sixty seconds of freefall over the world's most cinematic drop zones — the Palm Jumeirah from 13,000 ft, the Swiss Alps above Interlaken, Queenstown's Remarkables, or India's own Mysore drop zone. Every journey wraps your jump inside a curated luxury break: five-star stays, private transfers, video packages and time to celebrate after.",
        highlights: [
            "Tandem jumps with world-class, safety-audited drop zones",
            "Dubai Palm, Swiss Alps, Queenstown, Seville & Mysore options",
            "HD video & photo package of your jump included",
            "Luxury hotel stays, private transfers and celebration dinners built in",
            "No experience needed — first-time jumpers welcome from age 18",
        ],
        itinerary: [
            { d: "Day 1", t: "Arrive & unwind", x: "Private transfer to your hotel, briefing over dinner, early night before jump day." },
            { d: "Day 2", t: "Jump day", x: "Morning weather window — training, gear-up, 13,000 ft climb and the sixty seconds you'll never forget. Champagne debrief." },
            { d: "Day 3", t: "Weather buffer & city", x: "Built-in backup jump window, then the city on your terms — desert safari, lake cruise or vineyard lunch." },
            { d: "Days 4+", t: "Extend", x: "Add a second drop zone, an Interlaken–Zermatt rail leg, or Queenstown adventure add-ons." },
        ],
        faqs: [
            { q: "Is it safe for first-timers?", a: "Tandem skydiving pairs you with a master-rated instructor who manages everything — you simply enjoy the view. We work only with drop zones holding top national safety certifications." },
            { q: "What does it cost?", a: "From ₹1,99,999 per person + taxes for a 3-day Dubai Palm jump package including the tandem jump, video package, 5-star stay and transfers. Alpine and NZ packages quoted per season." },
            { q: "What if weather cancels the jump?", a: "Every itinerary carries a built-in buffer day. If weather still intervenes, the jump fee is refunded or re-booked — the concierge handles it." },
        ],
    },
    {
        slug: "explora-journeys",
        name: "Explora Journeys — Luxury Ocean Voyages",
        strap: "An Ocean State of Mind, Booked by Your Concierge",
        titleSuffix: "Ultra-Luxury Cruise Collection",
        overline: "Partner Collection · Ultra-Luxury Cruising",
        heroImage: "/api/assets/img/explora-cruise-premium.jpg",
        priceInr: 499999,
        priceUsd: 5699,
        priceEur: 5299,
        duration: "7 – 30 nights · 700+ voyages",
        bestTime: "Year-round departures",
        regions: ["Mediterranean", "Northern Europe & Iceland", "Caribbean", "Alaska", "Asia", "Arabian Peninsula"],
        externalUrl: "https://explorajourneys.com/int/en/find-your-journey?insider=w3rw0-yogesh-srivastava",
        externalLabel: "Browse Explora voyages",
        externalNote: "Assisted booking — browse voyages on Explora Journeys, then our concierge completes your reservation, suite selection and onboard benefits for you. No direct online booking needed.",
        summary:
            "Europe's newest ultra-luxury ocean line — six sleek ships (EXPLORA I–VI) from the MSC family, sailing 700+ voyages across the Mediterranean, Northern Europe & Iceland, the Caribbean, Alaska, Asia and the Arabian Peninsula. All ocean-front suites with private terraces, nine dining venues, and a quiet, residential elegance closer to a private yacht than a cruise ship. As an Explora travel partner, MyEcoTour hand-matches your voyage, suite and fare — and manages the entire reservation for you.",
        highlights: [
            "Six ships — EXPLORA I to VI — all ocean-front suites with private terraces",
            "7 to 30-night voyages: Mediterranean, Iceland, Caribbean, Alaska, Asia & Arabia",
            "All-inclusive dining across nine venues, wellness decks & infinity pools",
            "Signature sailings: Formula 1 Grand Prix de Monaco & festive season voyages",
            "Concierge-assisted booking — we secure suites, fares & Explora Club benefits",
        ],
        itinerary: [
            { d: "Step 1", t: "Browse & shortlist", x: "Explore 700+ voyages on Explora's site via our partner link — or simply tell the concierge your dates and dream regions." },
            { d: "Step 2", t: "Concierge curation", x: "We shortlist the right ship, itinerary, suite category and current offer (early-booking and Explora Club savings included)." },
            { d: "Step 3", t: "We book for you", x: "Reservation, suite selection, dining and shore experiences handled end-to-end — with flights and pre/post-cruise stays if you wish." },
            { d: "Step 4", t: "Sail", x: "Board with everything arranged; our desk stays on WhatsApp throughout your voyage." },
        ],
        faqs: [
            { q: "Can I book online directly?", a: "Explora voyages through MyEcoTour are assisted bookings — you browse freely, and our concierge completes the reservation for you. This ensures the best available fare, suite placement and any Explora Club benefits are applied correctly." },
            { q: "What does a voyage cost?", a: "Indicative from ₹4,99,999 (~$5,699) per guest onwards for a 7-night Mediterranean voyage in an ocean-front suite; longer and premium-season voyages are quoted by the concierge with current offers applied." },
            { q: "How is Explora different from a cruise?", a: "Think boutique ocean residence: no crowds, no queues, all-suite accommodation, destination-led itineraries with overnight port stays — closer to a private yacht with the space of a ship." },
        ],
    },
    {
        slug: "formula-1-grand-prix",
        name: "Formula 1 Grand Prix",
        strap: "Race Weekends, Engineered for Luxury",
        titleSuffix: "Grand Prix Hospitality Journeys",
        overline: "Signature Events · Grand Prix Weekends",
        heroImage: "/api/assets/img/formula1-premium.jpg",
        priceInr: 2499999,
        priceUsd: 29999,
        priceEur: 27999,
        duration: "4 – 6 days · race weekend",
        bestTime: "March – December · race calendar",
        regions: ["Monaco", "Abu Dhabi", "Singapore", "Silverstone", "Monza"],
        raceCalendar: [
            { round: 1, gp: "Australian Grand Prix", city: "Melbourne", circuit: "Albert Park Circuit", start: "2026-03-06", end: "2026-03-08" },
            { round: 2, gp: "Chinese Grand Prix", city: "Shanghai", circuit: "Shanghai International Circuit", start: "2026-03-13", end: "2026-03-15", sprint: true },
            { round: 3, gp: "Japanese Grand Prix", city: "Suzuka", circuit: "Suzuka Circuit", start: "2026-03-27", end: "2026-03-29" },
            { round: 4, gp: "Bahrain Grand Prix", city: "Sakhir", circuit: "Bahrain International Circuit", start: "2026-04-10", end: "2026-04-12" },
            { round: 5, gp: "Saudi Arabian Grand Prix", city: "Jeddah", circuit: "Jeddah Corniche Circuit", start: "2026-04-17", end: "2026-04-19" },
            { round: 6, gp: "Miami Grand Prix", city: "Miami", circuit: "Miami International Autodrome", start: "2026-05-01", end: "2026-05-03", sprint: true },
            { round: 7, gp: "Canadian Grand Prix", city: "Montreal", circuit: "Circuit Gilles Villeneuve", start: "2026-05-22", end: "2026-05-24", sprint: true },
            { round: 8, gp: "Monaco Grand Prix", city: "Monaco", circuit: "Circuit de Monaco", start: "2026-06-05", end: "2026-06-07", signature: true },
            { round: 9, gp: "Spanish Grand Prix", city: "Barcelona", circuit: "Circuit de Barcelona-Catalunya", start: "2026-06-12", end: "2026-06-14" },
            { round: 10, gp: "Austrian Grand Prix", city: "Spielberg", circuit: "Red Bull Ring", start: "2026-06-26", end: "2026-06-28" },
            { round: 11, gp: "British Grand Prix", city: "Silverstone", circuit: "Silverstone Circuit", start: "2026-07-03", end: "2026-07-05", sprint: true, signature: true },
            { round: 12, gp: "Belgian Grand Prix", city: "Spa-Francorchamps", circuit: "Circuit de Spa-Francorchamps", start: "2026-07-17", end: "2026-07-19" },
            { round: 13, gp: "Hungarian Grand Prix", city: "Budapest", circuit: "Hungaroring", start: "2026-07-24", end: "2026-07-26" },
            { round: 14, gp: "Dutch Grand Prix", city: "Zandvoort", circuit: "Circuit Zandvoort", start: "2026-08-21", end: "2026-08-23", sprint: true },
            { round: 15, gp: "Italian Grand Prix", city: "Monza", circuit: "Monza Circuit", start: "2026-09-04", end: "2026-09-06", signature: true },
            { round: 16, gp: "Spanish Grand Prix — Madrid", city: "Madrid", circuit: "Madring", start: "2026-09-11", end: "2026-09-13" },
            { round: 17, gp: "Azerbaijan Grand Prix", city: "Baku", circuit: "Baku City Circuit", start: "2026-09-24", end: "2026-09-26" },
            { round: 18, gp: "Singapore Grand Prix", city: "Singapore", circuit: "Marina Bay Street Circuit", start: "2026-10-09", end: "2026-10-11", sprint: true, signature: true },
            { round: 19, gp: "United States Grand Prix", city: "Austin", circuit: "Circuit of the Americas", start: "2026-10-23", end: "2026-10-25" },
            { round: 20, gp: "Mexico City Grand Prix", city: "Mexico City", circuit: "Autódromo Hermanos Rodríguez", start: "2026-10-30", end: "2026-11-01" },
            { round: 21, gp: "São Paulo Grand Prix", city: "São Paulo", circuit: "Interlagos Circuit", start: "2026-11-06", end: "2026-11-08" },
            { round: 22, gp: "Las Vegas Grand Prix", city: "Las Vegas", circuit: "Las Vegas Strip Circuit", start: "2026-11-19", end: "2026-11-21" },
            { round: 23, gp: "Qatar Grand Prix", city: "Lusail", circuit: "Lusail International Circuit", start: "2026-11-27", end: "2026-11-29" },
            { round: 24, gp: "Abu Dhabi Grand Prix", city: "Yas Marina", circuit: "Yas Marina Circuit", start: "2026-12-04", end: "2026-12-06", signature: true },
        ],
        summary:
            "The world's fastest weekend, moved into the slow lane of luxury — Paddock Club hospitality above the pit lane, superyacht viewing in Monaco's harbour, Marina Bay under lights in Singapore, and the twilight finale at Abu Dhabi's Yas Marina. Every journey pairs premium race access with five-star stays, chauffeured transfers and the city's finest tables.",
        highlights: [
            "Paddock Club & premium grandstand hospitality with pit-lane walks",
            "Monaco harbour superyacht viewing decks (race-day trackside berths)",
            "Five-star hotels, chauffeured transfers & priority circuit access",
            "Driver appearances, team-garage tours & gourmet trackside dining",
            "Pair Monaco with an Explora Journeys Grand Prix voyage — ask the concierge",
        ],
        itinerary: [
            { d: "Day 1", t: "Arrival", x: "Private transfer to your hotel, welcome dinner, race-week orientation with your host." },
            { d: "Day 2", t: "Practice day", x: "Circuit access for free practice, pit-lane walk and team-garage tour where available." },
            { d: "Day 3", t: "Qualifying", x: "Qualifying from your hospitality suite; evening at the city's signature tables or a harbour party." },
            { d: "Day 4", t: "Race day", x: "The Grand Prix from Paddock Club or premium grandstand — champagne podium finish." },
            { d: "Days 5–6", t: "Decompress", x: "Riviera drive, desert escape or island day — then a chauffeured departure." },
        ],
        faqs: [
            { q: "Which races can you arrange?", a: "Monaco, Abu Dhabi, Singapore, Silverstone and Monza are our signature weekends — but we can build packages around most of the F1 calendar, subject to hospitality availability." },
            { q: "What does it cost?", a: "From ₹24,99,999 per person + taxes for a 4-day race weekend with premium hospitality, five-star stays and transfers. Monaco Paddock Club and superyacht berths are quoted on request — book 6–9 months ahead." },
            { q: "Can we watch Monaco from the water?", a: "Yes — trackside yacht berths and Explora Journeys' Grand Prix de Monaco voyages put you on the harbour itself. The concierge arranges both." },
        ],
    },
];
